import React, { useState } from "react";
import styles from "../../../Meta.module.css";
import AddAutoCompleteField from "../../../../../../../../components/AutoCompleteField/AddAutoCompleteField";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import NewFormTextInput from "../../../../../../../../components/FormTextInput/NewFormTextInput";
import AutoCompleteField from "../../../../../../../../components/AutoCompleteField/AutoCompleteField";
import PageBackBtn from "../../../../../../../../components/Buttons/PageBackBtn";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";
import checkIcon from "../../../../../../../../assets/images/checked-icon.svg";
import { FormHelperText } from "@mui/material";
import { useDispatch } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import {
  addMetaAccount,
  addMetaStream,
  deleteMetaAccount,
  editMetaStream,
  getMetaAccountPages,
  getMetaAdAccount,
  getMetaIntegratedAccounts,
  getMetaPageForms,
  getStreamById,
  getStreams,
  resetMetaStatuses,
  resetMetaStreamById,
  updateMetaStreamStatus,
} from "../../../../../service/IntegrationsSlice";
import AutoCompleteFilter from "../../../../../../Reports/components/Filters/AutoCompleteFilter";
import Loader from "../../../../../../../../components/Loader/Loader";
import DeletePopup from "../../../../../../../../components/CommonPopups/DeletePopup";
import SwitchInput from "../../../../../../../../components/Switch/SwitchInput";
import { getInstituteById } from "../../../../../../Manage/InstituteProfile/service/instituteSlice";
import { checkObjectsEqual } from "../../../../../../../../components/CommonFunctions/CommonFunctions";

const metaDetais = [
  {
    title: "Enhanced Lead Management",
    list: [
      {
        desc: "Automatically capture leads from Facebook and Instagram ads directly into your CRM.",
      },
      {
        desc: "Eliminate manual data entry and reduce lead leakage.",
      },
    ],
  },
  {
    title: "Real-Time Lead Syncing",
    list: [
      {
        desc: "Instantly sync new leads with your CRM to enable faster follow-ups.",
      },
      {
        desc: "Improve response times and increase conversion rates.",
      },
    ],
  },
  {
    title: "Automated Lead Nurturing",
    list: [
      {
        desc: "Set up automated email, SMS, or WhatsApp workflows to nurture leads.",
      },
      {
        desc: "Engage prospects at the right time with the right message.",
      },
    ],
  },

  {
    title: "Better ROI Tracking & Attribution",
    list: [
      {
        desc: "Track the full customer journey from ad click to conversion.",
      },
      {
        desc: "Measure which campaigns generate the most revenue and optimize ad spend.",
      },
    ],
  },

  {
    title: "Seamless Retargeting",
    list: [
      {
        desc: "Retarget CRM contacts who haven’t completed a purchase or shown interest.",
      },
      {
        desc: "Use dynamic ads to show relevant products or services based on past behavior.",
      },
    ],
  },
  {
    title: "Improved Sales & Marketing Alignment",
    list: [
      {
        desc: "Give sales teams instant access to ad-generated leads for immediate follow-up.",
      },
      {
        desc: "Ensure marketing and sales efforts are aligned for better efficiency.",
      },
    ],
  },
];

function ConnectStream(props: any) {
  const {
    setConnectStage,
    validStateName,
    streamName,
    handleStreamName,
    setValidStateName,
    setStreamName,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const {
    metaAccounts,
    metaPages,
    metaForms,
    metaAds,
    addAccountLoading,
    addAccountSuccess,
    addStreamSuccess,
    addStreamLoading,
    metaAccountsLoading,
    metaPagesLoading,
    metaAdsLoading,
    metaFormsLoading,
    createdStreamId,
    streamByIdLoading,
    streamById,
    deleteMetaAccountLoading,
    deleteMetaAccountSuccess,
    editStreamLoading,
    editStreamSuccess,
    metaAccountId,
    streamStatusSuccess,
  } = useSelector((state: any) => state.appIntegrations);
  const { branchList } = useSelector((state: any) => state.branch);
  const filteredBranchList = hasAllBranchAccess
    ? branchList
    : branchList?.filter((branch: any) => branch.id === userById?.branchId);

  const [selectedBranches, setSelectedBranches] = useState<any>(null);
  const [validStateBranch, setValidStateBranch] = React.useState<boolean>(true);
  const [selectedAccount, setSelectedAccount] = useState<any>(null);
  const [selectedAdAccount, setSelectedAdAccount] = useState<any>(null);
  const [selectedPage, setSelectedPage] = useState<any>(null);
  const [selectedForm, setSelectedForm] = useState<any>(null);
  const [validStateAccount, setValidStateAccount] =
    React.useState<boolean>(true);
  const [validStateAdAccount, setValidStateAdAccount] =
    React.useState<boolean>(true);
  const [validStatePage, setValidStatePage] = React.useState<boolean>(true);
  const [validStateForm, setValidStateForm] = React.useState<boolean>(true);
  const [accountDelete, setAccountDelete] = React.useState<boolean>(false);
  const [deleteAccount, setDeleteAccount] = useState<any>(null);
  const [streamStatus, setStreamStatus] = useState<boolean>(false);

  const onAccountChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedAccount(value);
        setValidStateAccount(true);
        dispatch<any>(
          getMetaAdAccount({
            id: activeInstitute?.id,
            metaAccountId: value?.metaAccountId,
          })
        );

        dispatch<any>(
          getMetaAccountPages({
            id: activeInstitute?.id,
            metaAccountId: value?.metaAccountId,
          })
        );
      } else {
        setSelectedAccount(null);

        setValidStateAccount(false);
      }
      setSelectedAdAccount(null);
      setSelectedForm(null);
      setSelectedPage(null);
      setValidStateForm(true);
      setValidStatePage(true);
      setValidStateAdAccount(true);
      setSelectedBranches(null);
      setValidStateBranch(true);
    },
    []
  );
  const onAdAccountChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedAdAccount(value);
        setValidStateAdAccount(true);
      } else {
        setSelectedAdAccount(null);

        setValidStateAdAccount(false);
      }
      setSelectedForm(null);
      setSelectedPage(null);
      setValidStateForm(true);
      setValidStatePage(true);
    },
    []
  );

  const onPageChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedPage(value);
        setValidStatePage(true);
        dispatch<any>(
          getMetaPageForms({
            id: activeInstitute?.id,
            metaAccountId: selectedAccount?.metaAccountId,
            pageId: value?.id,
          })
        );
      } else {
        setSelectedPage(null);
        setValidStatePage(false);
      }
      setSelectedForm(null);
      setValidStateForm(true);
    },
    [selectedAccount]
  );

  const onFormChange = React.useCallback((event: object, value: any | null) => {
    if (value !== null) {
      setSelectedForm(value);
      setValidStateForm(true);
    } else {
      setSelectedForm(null);
      setValidStateForm(false);
    }
  }, []);

  const onBranchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value && value?.hasOwnProperty("isAddButton")) {
      } else {
        if (value !== null) {
          setSelectedBranches(value);
          setValidStateBranch(true);
        } else {
          setSelectedBranches(null);
          setValidStateBranch(false);
        }
      }
    },
    []
  );
  const onAccountDelete = React.useCallback(
    (value: any | null) => {
      setAccountDelete(true);
      setDeleteAccount(value);
      const checkAccount = metaAccounts?.find(
        (item: any) => item?.metaAccountId === value?.metaAccountId
      );
      if (checkAccount) {
        setSelectedAccount(null);
      }
    },
    [metaAccounts]
  );

  const handleDeleteClosePopup = () => {
    setDeleteAccount(null);
    setAccountDelete(false);
  };
  const handleDelete = () => {
    dispatch<any>(
      deleteMetaAccount({
        id: activeInstitute?.id,
        accountId: deleteAccount?.metaAccountId,
      })
    );
  };
  const handlePageBack = () => {
    setConnectStage(0);
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete("streamId");
    urlSearchParams.delete("streamStage");
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    dispatch<any>(
      getStreams({
        id: activeInstitute?.id,
        status: "",
        branchId: hasAllBranchAccess ? "" : userById?.branchId,
      })
    );
    dispatch<any>(resetMetaStreamById());
  };

  const metaRedirection = () => {
    const CONFIG_ID = "1112635727277443";
    const FACEBOOK_APP_ID = "3911241252484585";
    const REDIRECT_URI = process.env.REACT_APP_META_REDIRECT_URL || "";

    const domain = window.location.host;
    const targetUrl = `https://${domain}/app/Integrations/MetaIntegration/`;
    const authUrl = `https://www.facebook.com/v22.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${REDIRECT_URI}&config_id=${CONFIG_ID}&state=${targetUrl}`;
    window.location.href = authUrl;
  };
  const saveDisable =
    selectedAccount === null ||
    selectedAdAccount === null ||
    selectedPage === null ||
    selectedForm === null ||
    selectedBranches === null ||
    streamName === "";
  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      !selectedAccount && setValidStateAccount(false);
      !selectedAdAccount && setValidStateAdAccount(false);
      !selectedPage && setValidStatePage(false);
      !selectedForm && setValidStateForm(false);
      !selectedBranches && setValidStateBranch(false);
      !streamName && setValidStateName(false);
      const body = {
        streamName: streamName,
        metaAccountName: selectedAccount?.metaAccountName,
        metaAccountId: selectedAccount?.metaAccountId,
        metaAdAccountName: selectedAdAccount?.name,
        metaAdAccountId: selectedAdAccount?.id,
        metaPageName: selectedPage?.name,
        metaPageId: selectedPage?.id,
        metaFormName: selectedForm?.name,
        metaFormId: selectedForm?.id,
        branch: selectedBranches?.map((item: any) => item?.id),
        instituteId: activeInstitute?.id,
        createdById: authUser?.institute[0]?.id,
        createdByName: authUser?.firstName + " " + authUser?.lastName,
      };
      streamName !== "" &&
        validStateAccount &&
        validStateForm &&
        validStatePage &&
        validStateBranch &&
        validStateAdAccount &&
        dispatch<any>(addMetaStream(body));
    } catch (error) {}
  };

  const handleUpdate = async (event: any) => {
    event.preventDefault();

    try {
      !selectedAccount && setValidStateAccount(false);
      !selectedAdAccount && setValidStateAdAccount(false);
      !selectedPage && setValidStatePage(false);
      !selectedForm && setValidStateForm(false);
      !selectedBranches && setValidStateBranch(false);
      !streamName && setValidStateName(false);
      const body = {
        streamName: streamName,
        metaAccountName: selectedAccount?.metaAccountName,
        metaAccountId: selectedAccount?.metaAccountId,
        metaAdAccountName: selectedAdAccount?.name,
        metaAdAccountId: selectedAdAccount?.id,
        metaPageName: selectedPage?.name,
        metaPageId: selectedPage?.id,
        metaFormName: selectedForm?.name,
        metaFormId: selectedForm?.id,
        branch: selectedBranches?.map((item: any) => item?.id),
        instituteId: activeInstitute?.id,
        updatedById: authUser?.institute[0]?.id,
        updatedByName: authUser?.firstName + " " + authUser?.lastName,
        id: streamById?.id,
      };
      streamName !== "" &&
        validStateAccount &&
        validStateForm &&
        validStatePage &&
        validStateBranch &&
        validStateAdAccount &&
        dispatch<any>(editMetaStream(body));
    } catch (error) {}
  };
  const handleStatusUpdate = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    const newStatus = isChecked ? "ACTIVE" : "INACTIVE";

    setStreamStatus(isChecked);

    try {
      const body = {
        status: newStatus,
        streamId: streamById?.id,
      };

      await dispatch<any>(updateMetaStreamStatus(body));
    } catch (error) {
      console.error("Status update failed:", error);
      setStreamStatus((prev) => !prev);
    }
  };
  const isObjectsEqual = checkObjectsEqual(
    { name: streamById?.streamName, branches: streamById?.branch },
    {
      name: streamName,
      branches: selectedBranches?.map((item: any) => item?.id)?.reverse(),
    }
  );

  React.useEffect(() => {
    if (activeInstitute?.id) {
      const urlSearchParams = new URLSearchParams(window.location.search);

      const code = urlSearchParams.get("code");
      if (!code) {
        dispatch<any>(getMetaIntegratedAccounts(activeInstitute?.id));
      }
      const streamId = urlSearchParams.get("streamId");

      if (activeInstitute?.id && streamId) {
        dispatch<any>(getStreamById(streamId));
      }
    }
  }, []);
  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const metaCode = urlSearchParams.get("code");

    if (metaCode) {
      const body = {
        code: metaCode,
        instituteId: activeInstitute?.id,
        createdByName: `${authUser?.firstName} ${authUser?.lastName}`,
        createdById: authUser?.institute?.[0]?.id,
      };
      dispatch<any>(addMetaAccount(body));
    }
  }, []);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const streamId = urlSearchParams.get("streamId");

    if (streamById?.metaAccountId && streamId) {
      dispatch<any>(
        getMetaAdAccount({
          id: activeInstitute?.id,
          metaAccountId: streamById?.metaAccountId,
        })
      );

      dispatch<any>(
        getMetaAccountPages({
          id: activeInstitute?.id,
          metaAccountId: streamById?.metaAccountId,
        })
      );
      dispatch<any>(
        getMetaPageForms({
          id: activeInstitute?.id,
          metaAccountId: streamById?.metaAccountId,
          pageId: streamById?.metaPageId,
        })
      );
    }
  }, [streamById]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const streamId = urlSearchParams.get("streamId");

    if (streamById && streamId) {
      setStreamName(streamById?.streamName);
      if (metaAccounts) {
        const findAccount = metaAccounts?.find(
          (item: any) => item.metaAccountId === streamById?.metaAccountId
        );

        setSelectedAccount(findAccount);
      }
      if (filteredBranchList && streamById?.branch) {
        const matchedBranches = filteredBranchList?.filter((branch: any) =>
          streamById?.branch.includes(branch.id)
        );
        setSelectedBranches(matchedBranches);
      }
    } else {
      setStreamName("");
    }
  }, [streamById, metaAccounts, branchList]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const streamId = urlSearchParams.get("streamId");

    if (streamById && streamId) {
      setStreamStatus(streamById?.status === "ACTIVE" ? true : false);
      if (metaAds) {
        const findAdAccount = metaAds?.find(
          (item: any) => item.id === streamById?.metaAdAccountId
        );

        setSelectedAdAccount(findAdAccount);
      }
      if (metaPages) {
        const findPage = metaPages?.find(
          (item: any) => item.id === streamById?.metaPageId
        );

        setSelectedPage(findPage);
      }
      if (metaForms) {
        const findForm = metaForms?.find(
          (item: any) => item.id === streamById?.metaFormId
        );

        setSelectedForm(findForm);
      }
    }
  }, [streamById, metaForms, metaPages, metaAds]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (
      addAccountSuccess !== true &&
      addAccountSuccess !== false &&
      metaAccountId
    ) {
      if (activeInstitute?.id) {
        dispatch<any>(getMetaIntegratedAccounts(activeInstitute?.id));
        dispatch<any>(getInstituteById(authUser?.institute?.[0]?.instituteId));
      }
      urlSearchParams.delete("code");
      urlSearchParams.delete("state");
      urlSearchParams.set("metaAccount", metaAccountId);
      const newUrl = `${
        window.location.pathname
      }?${urlSearchParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    }
  }, [addAccountSuccess, metaAccountId]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (metaAccountId && metaAccounts) {
      const accountId = urlSearchParams.get("metaAccount");
      const defaultAccount = metaAccounts?.find(
        (item: any) => item?.metaAccountId === accountId
      );
      setSelectedAccount(defaultAccount);
      dispatch<any>(
        getMetaAdAccount({
          id: activeInstitute?.id,
          metaAccountId: defaultAccount?.metaAccountId,
        })
      );

      dispatch<any>(
        getMetaAccountPages({
          id: activeInstitute?.id,
          metaAccountId: defaultAccount?.metaAccountId,
        })
      );

      urlSearchParams.delete("metaAccount");
      const newUrl = `${
        window.location.pathname
      }?${urlSearchParams.toString()}`;
      window.history.pushState({}, "", newUrl);

      dispatch<any>(resetMetaStatuses());
    }
  }, [metaAccounts, metaAccountId]);

  React.useEffect(() => {
    if (
      addStreamSuccess !== true &&
      addStreamSuccess !== false &&
      createdStreamId
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      urlSearchParams.set("streamId", createdStreamId);
      const newUrl = `${
        window.location.pathname
      }?${urlSearchParams.toString()}`;
      window.history.pushState({}, "", newUrl);
      setConnectStage(2);
      dispatch<any>(resetMetaStatuses());
    }
  }, [addStreamSuccess, createdStreamId]);

  React.useEffect(() => {
    if (editStreamSuccess !== true && editStreamSuccess !== false) {
      if (streamById?.status === "DRAFT") {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set("streamId", createdStreamId);
        const newUrl = `${
          window.location.pathname
        }?${urlSearchParams.toString()}`;
        window.history.pushState({}, "", newUrl);
        setConnectStage(2);
      } else {
        dispatch<any>(
          getStreams({
            id: activeInstitute?.id,
            status: "",
            branchId: hasAllBranchAccess ? "" : userById?.branchId,
          })
        );
        dispatch<any>(resetMetaStreamById());
        setConnectStage(0);
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete("streamId");
        const newUrl = `${
          window.location.pathname
        }?${urlSearchParams.toString()}`;
        window.history.pushState({}, "", newUrl);
      }

      dispatch<any>(resetMetaStatuses());
    }
  }, [editStreamSuccess, streamById]);

  React.useEffect(() => {
    if (
      deleteMetaAccountSuccess !== true &&
      deleteMetaAccountSuccess !== false
    ) {
      if (activeInstitute?.id) {
        dispatch<any>(getMetaIntegratedAccounts(activeInstitute?.id));
      }
      setAccountDelete(false);
      setDeleteAccount(null);
      if (deleteAccount?.metaAccountId === selectedAccount?.metaAccountId) {
        setSelectedAdAccount(null);
        setSelectedForm(null);
        setSelectedPage(null);
        setValidStateForm(true);
        setValidStatePage(true);
        setValidStateAdAccount(true);
        setSelectedBranches(null);
        setValidStateBranch(true);
      }
      dispatch<any>(resetMetaStatuses());
    }
  }, [deleteMetaAccountSuccess, deleteAccount, selectedAccount]);
  React.useEffect(() => {
    if (streamStatusSuccess !== true && streamStatusSuccess !== false) {
      const urlSearchParams = new URLSearchParams(window.location.search);

      const streamId = urlSearchParams.get("streamId");

      if (activeInstitute?.id && streamId) {
        dispatch<any>(getStreamById(streamId));
        dispatch<any>(resetMetaStatuses());
      }
    }
  }, [streamStatusSuccess]);

  return (
    <div>
      <div className={styles.connectHead}>
        <div style={{ marginBottom: !validStateName ? "24px" : "0" }}>
          <PageBackBtn iconOnly={true} onClick={handlePageBack} />
        </div>

        <div className={styles.streamFieldName}>
          <div className={styles.fieldBox}>
            <NewFormTextInput
              value={streamName}
              onChange={handleStreamName}
              placeholder="Stream name"
              inputProps={{
                maxLength: 20,
              }}
            />
          </div>
          {!validStateName && (
            <FormHelperText sx={{ marginLeft: "8px" }} error>
              Field required
            </FormHelperText>
          )}
        </div>
      </div>

      <div className={styles.connectWrap}>
        <div className={styles.connectLeft}>
          <div className={styles.connectLeftChild}>
            <div className={styles.connectFormHeadWrap}>
              <div
                className={styles.connectTitle}
                style={{ marginBottom: "0px" }}
              >
                Connect Your Apps
              </div>
              {streamById && streamById?.status !== "DRAFT" && (
                <div>
                  <SwitchInput
                    switchStatus={streamStatus}
                    handleSwitch={handleStatusUpdate}
                    label={streamStatus ? "Active" : "Inactive"}
                  />
                </div>
              )}
            </div>

            <div className={styles.fieldsWrapper}>
              <div className={styles.fieldWrap}>
                <div className={styles.fieldLabel}>Ad Source</div>
                <div className={styles.fieldBox}>
                  <NewFormTextInput
                    disabled
                    value={"FACEBOOK_AND_INSTAGRAM_ADS"
                      .toLowerCase()
                      .replace(/_/g, " ")}
                  />
                </div>
              </div>
              <div className={styles.fieldWrap}>
                <div className={styles.fieldLabel}>
                  Connect Your Facebook Account
                </div>
                <div className={styles.fieldBox}>
                  <AddAutoCompleteField
                    id="metaAccount"
                    options={metaAccounts}
                    optionLabel={"metaAccountName"}
                    onChange={onAccountChange}
                    value={selectedAccount}
                    disableClearable={selectedAccount === null ? true : false}
                    validState={true}
                    onAddClick={metaRedirection}
                    disabled={streamById && streamById?.status === "ACTIVE"}
                    onDeleteClick={onAccountDelete}
                  />
                </div>
                {!validStateAccount && (
                  <FormHelperText sx={{ marginLeft: "8px" }} error>
                    Field required
                  </FormHelperText>
                )}
              </div>
              {metaAdsLoading ? (
                <Loader />
              ) : (
                <>
                  {selectedAccount && metaAds?.length > 0 && (
                    <div className={styles.fieldWrap}>
                      <div className={styles.fieldLabel}>
                        Choose Your Facebook Ad Account
                      </div>
                      <div className={styles.fieldBox}>
                        <AutoCompleteField
                          id="metaAdAccount"
                          options={metaAds}
                          optionLabel={"name"}
                          onChange={onAdAccountChange}
                          value={selectedAdAccount}
                          disableClearable={
                            selectedAdAccount === null ? true : false
                          }
                          validState={true}
                          disabled={streamById?.status === "ACTIVE"}
                        />
                      </div>
                      {!validStateAdAccount && (
                        <FormHelperText sx={{ marginLeft: "8px" }} error>
                          Field required
                        </FormHelperText>
                      )}
                    </div>
                  )}
                  {metaPagesLoading ? (
                    <Loader />
                  ) : (
                    <>
                      {selectedAdAccount && metaPages?.length > 0 && (
                        <div className={styles.fieldWrap}>
                          <div className={styles.fieldLabel}>
                            Choose Your Facebook Page
                          </div>
                          <div className={styles.fieldBox}>
                            <AutoCompleteField
                              id="metaPage"
                              options={metaPages}
                              optionLabel={"name"}
                              onChange={onPageChange}
                              value={selectedPage}
                              disableClearable={
                                selectedPage === null ? true : false
                              }
                              validState={true}
                              disabled={streamById?.status === "ACTIVE"}
                            />
                          </div>
                          {!validStatePage && (
                            <FormHelperText sx={{ marginLeft: "8px" }} error>
                              Field required
                            </FormHelperText>
                          )}
                        </div>
                      )}
                      {metaFormsLoading ? (
                        <Loader />
                      ) : (
                        <>
                          {selectedPage && metaForms?.length > 0 && (
                            <div className={styles.fieldWrap}>
                              <div className={styles.fieldLabel}>
                                Facebook Form
                              </div>
                              <div className={styles.fieldBox}>
                                <AutoCompleteField
                                  id="metaForm"
                                  options={metaForms}
                                  optionLabel={"name"}
                                  onChange={onFormChange}
                                  value={selectedForm}
                                  disableClearable={
                                    selectedForm === null ? true : false
                                  }
                                  validState={true}
                                  disabled={streamById?.status === "ACTIVE"}
                                />
                              </div>
                              {!validStateForm && (
                                <FormHelperText
                                  sx={{ marginLeft: "8px" }}
                                  error
                                >
                                  Field required
                                </FormHelperText>
                              )}
                            </div>
                          )}
                          {selectedForm && filteredBranchList?.length > 0 && (
                            <div className={styles.fieldWrap}>
                              <div className={styles.fieldLabel}>
                                Select a Branch
                              </div>
                              <div className={styles.fieldBox}>
                                <AutoCompleteFilter
                                  id="branchId"
                                  options={filteredBranchList}
                                  optionLabel={"branchName"}
                                  onChange={onBranchChange}
                                  value={selectedBranches}
                                  disableClearable={
                                    selectedBranches === null ? true : false
                                  }
                                  validState={true}
                                  multiSelect={true}
                                  width={"100%"}
                                  listType="BRANCH"
                                />
                              </div>
                              {!validStateBranch && (
                                <FormHelperText
                                  sx={{ marginLeft: "8px" }}
                                  error
                                >
                                  Field required
                                </FormHelperText>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              <div className={styles.connectSubmitBtn}>
                {streamById === null ? (
                  <SaveBtn
                    buttonText={"Proceed to mapping"}
                    onClick={handleSubmit}
                    disabled={saveDisable || addStreamLoading}
                    loader={addStreamLoading}
                  />
                ) : (
                  <>
                    <SaveBtn
                      buttonText={
                        streamById?.status !== "DRAFT"
                          ? "Save Changes"
                          : "Proceed to mapping"
                      }
                      onClick={handleUpdate}
                      disabled={
                        saveDisable ||
                        editStreamLoading ||
                        (streamById?.status !== "DRAFT" && isObjectsEqual)
                      }
                      loader={editStreamLoading}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.connectRight}>
          <div className={styles.metaMainDesc}>
            Integrating your Meta Ad Account with a Nurture system unlocks
            powerful capabilities to streamline your marketing efforts and
            enhance customer engagement. :
          </div>
          {metaDetais?.map((item: any, index: number) => (
            <div className={styles.metaListItem} key={index}>
              <div className={styles.metaListItemHead}>
                <img src={checkIcon} alt="" />
                {item?.title}
              </div>
              <ul className={styles.metaListChildWrap}>
                {item?.list?.map((listItem: any, index: number) => (
                  <li className={styles.metaListChildItem} key={index}>
                    {listItem?.desc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <DeletePopup
        open={accountDelete}
        onClose={handleDeleteClosePopup}
        noBtnClick={handleDeleteClosePopup}
        yesBtnClick={handleDelete}
        loader={deleteMetaAccountLoading}
        title="Are you sure you want to delete this Account ?"
      />
    </div>
  );
}

export default ConnectStream;
